import { globalOnDemandVars } from '../helper/context'
import { findPathByIdFromTreeData, getNodeById } from '../helper/functions'
import { updateTreeNode } from '../backend/treeNode/updateData'
import { getScoreByRating } from './constants'
import { getNewRecord, getRatingAsNumber } from './SM2+'
import { changeNodeAtPath } from 'react-sortable-tree'
import { getNodeKey } from '../components/list/window1/functions'
import { downdateCardBySM2, updateCardBySM2, updateCardForFail } from './spreadsheet'
import { downdateFragmentBySM2, updateFragmentBySM2, updateFragmentForFail } from './uploadType2'

const DAY_IN_MINISECONDS = 24 * 60 * 60 * 1000
export const getTodayNumber = (noRound) => {
  // if (noRound) {
  //   return Math.floor(new Date().getTime() / DAY_IN_MINISECONDS)
  // } else {
  //   return Math.round(new Date().getTime() / DAY_IN_MINISECONDS)
  // }
  const DateObject = new Date()
  DateObject.setHours(0, 0, 0, 0)
  const DateObject2 = new Date(2000, 0, 1, 0, 0, 0, 0)
  return (DateObject.getTime() - DateObject2.getTime()) / DAY_IN_MINISECONDS
}
function getNewRecordOfNode (node, rating) {
  return getNewRecord({
    difficulty: node.editableValues.difficulty,
    interval: node.editableValues.interval,
    update: node.editableValues.update
  }, getRatingAsNumber(rating))
}

export function setLatestStatus (node) {
  if (node.editableValues.memorizingStatus) {
    node.editableValues.latestStatus = node.editableValues.memorizingStatus
  }
}

// 여기서 rating 은 string 으로 표시된거
export function updateNodeBySM2 (node, rating, updateIdentifier) {
  switch (rating) {
    case 'easy':
      break
    case 'normal':
      break
    case 'hard':
      break
    case 'fail':
      break
    case 'firstTime':
      break
    case 'reStudy':
      break
    case 'reTest':
      break
    default:
      if (process.env.NODE_ENV !== 'production') {
        console.tron.log(`logic / 이상한 rating at updateNodeBySM2: ${rating} `)
      }
      throw (new Error(`logic / 이상한 rating at updateNodeBySM2: ${rating} `))
  }

  if (node.isSpreadsheetNode) {
    updateCardBySM2(node, rating, updateIdentifier)
    return
  }
  if (node.isUploadType2Node) {
    updateFragmentBySM2(node, rating, updateIdentifier)
    return
  }

  const nodeId = node.id
  const gTD = globalOnDemandVars.globalTreeData()
  const nodeFromGTD = getNodeById(nodeId, gTD)

  let newRecord
  if (!node.editableValues.updateIdentifier || node.editableValues.updateIdentifier !== updateIdentifier) {
    node.editableValues.updateIdentifier = updateIdentifier
    if (process.env.NODE_ENV !== 'production') {
      console.tron.log('logic / updateIdentifier 담')
    }

    node.editableValues.prevRating = rating

    node.editableValues.prevRecord = {
      difficulty: nodeFromGTD.editableValues.difficulty,
      interval: nodeFromGTD.editableValues.interval,
      update: nodeFromGTD.editableValues.update
    }

    newRecord = getNewRecordOfNode(nodeFromGTD, rating)

    if (updateIdentifier.endsWith('reTest') && rating === 'hard') {
      newRecord.difficulty = nodeFromGTD.editableValues.difficulty
    }

    node.editableValues.difficulty = newRecord.difficulty
    node.editableValues.interval = newRecord.interval
    node.editableValues.update = newRecord.update

    // 1) gTD 변경

    nodeFromGTD.editableValues.difficulty = newRecord.difficulty
    nodeFromGTD.editableValues.interval = newRecord.interval
    nodeFromGTD.editableValues.update = newRecord.update

    nodeFromGTD.editableValues.ratingRecord.push({
      rating: rating,
      time: Date.now()
    })
    // -----------------------------------------------------------------------------------------------------------
    // 2) DB 업데이트
    updateTreeNode(nodeId, {
      difficulty: newRecord.difficulty,
      interval: newRecord.interval,
      update: newRecord.update,
      ratingRecord: nodeFromGTD.editableValues.ratingRecord
    })
  } else {
    newRecord = getNewRecord(node.editableValues.prevRecord, getRatingAsNumber(rating))

    if (updateIdentifier.endsWith('reTest') && rating === 'hard') {
      newRecord.difficulty = nodeFromGTD.editableValues.difficulty
    }

    node.editableValues.difficulty = newRecord.difficulty
    node.editableValues.interval = newRecord.interval
    node.editableValues.update = newRecord.update

    nodeFromGTD.editableValues.difficulty = newRecord.difficulty
    nodeFromGTD.editableValues.interval = newRecord.interval
    nodeFromGTD.editableValues.update = newRecord.update

    nodeFromGTD.editableValues.ratingRecord[nodeFromGTD.editableValues.ratingRecord.length - 1] = {
      rating: rating,
      time: Date.now()
    }
    // -----------------------------------------------------------------------------------------------------------
    // 2) DB 업데이트
    updateTreeNode(nodeId, {
      difficulty: newRecord.difficulty,
      interval: newRecord.interval,
      update: newRecord.update,
      ratingRecord: nodeFromGTD.editableValues.ratingRecord
    })
  }
}

export function downdateNodeBySM2 (node, updateIdentifier) {
  if (!node.editableValues.updateIdentifier || node.editableValues.updateIdentifier !== updateIdentifier) {
    throw (new Error('updateIdentifier 가 일치하지 않음 - 아마도 저번에 체크 안된거같은데 근데 downdate 를 하려고 했음'))
  }

  if (node.isSpreadsheetNode) {
    downdateCardBySM2(node)
    return
  }
  if (node.isUploadType2Node) {
    downdateFragmentBySM2(node)
    return
  }

  const prevRecord = node.editableValues.prevRecord
  const nodeId = node.id
  const gTD = globalOnDemandVars.globalTreeData()
  const nodeFromGTD = getNodeById(nodeId, gTD)
  nodeFromGTD.editableValues.difficulty = prevRecord.difficulty
  nodeFromGTD.editableValues.interval = prevRecord.interval
  nodeFromGTD.editableValues.update = prevRecord.update
  nodeFromGTD.editableValues.ratingRecord.pop()
  updateTreeNode(nodeId, {
    difficulty: prevRecord.difficulty,
    interval: prevRecord.interval,
    update: prevRecord.update,
    ratingRecord: nodeFromGTD.editableValues.ratingRecord
  })
  // updateIdentifier는 prevRecord 를 저장하려고 있는거처럼 보이는데... 그럴거면 null로 바꿀 필요 없겠지?
  // node.editableValues.updateIdentifier = null
}
export function isDueDate (node) {
  const todayNumber = getTodayNumber(true)
  const dueDate = node.editableValues.update + node.editableValues.interval
  const hasBackSide = node.isUploadType2Node || node.isSpreadsheetNode || node.subtitle
  return (
    hasBackSide && (todayNumber >= dueDate)
  )
}

export function updateNodeForFail (node, failStatus) {
  const nodeId = node.id

  if (node.isSpreadsheetNode) {
    updateCardForFail(node, failStatus)
    return
  }
  if (node.isUploadType2Node) {
    updateFragmentForFail(node, failStatus)
    return
  }

  const gTD = globalOnDemandVars.globalTreeData()
  const nodeFromGTD = getNodeById(nodeId, gTD)
  // 1) gTD 변경
  nodeFromGTD.editableValues.failStatus = failStatus
  // -----------------------------------------------------------------------------------------------------------
  // 2) DB 업데이트
  updateTreeNode(nodeId, {
    failStatus
  })
}
export function updateNodeValues (node, whatToUpdate, newValue) {
  if (process.env.NODE_ENV !== 'production') {
    console.tron.log('updateNode start')
  }
  const nodeId = node.id
  const gTD = globalOnDemandVars.globalTreeData()
  const nodePath = findPathByIdFromTreeData(nodeId, gTD)[1]
  if (process.env.NODE_ENV !== 'production') {
    console.tron.display({
      name: 'updateNode',
      value: {
        nodeId, gTD, nodePath, node, whatToUpdate, newValue
      }
      // , important: true
    })
  }
  if (!nodePath) {
    throw (new Error('path 안나옴'))
  }

  let newGTD
  if (whatToUpdate === 'title') {
    node.editableValues.newTitle = newValue

    newGTD = changeNodeAtPath({
      treeData: gTD,
      path: nodePath,
      newNode: ({ node }) => ({
        ...node,
        title: newValue
      }),
      getNodeKey: getNodeKey,
      ignoreCollapsed: false
    })
    globalOnDemandVars.set_globalTreeData(newGTD)

    updateTreeNode(nodeId, {
      title: newValue
    })
  } else if (whatToUpdate === 'subtitle') {
    node.editableValues.newSubtitle = newValue

    newGTD = changeNodeAtPath({
      treeData: gTD,
      path: nodePath,
      newNode: ({ node }) => ({
        ...node,
        subtitle: newValue
      }),
      getNodeKey: getNodeKey,
      ignoreCollapsed: false
    })
    globalOnDemandVars.set_globalTreeData(newGTD)

    updateTreeNode(nodeId, {
      subtitle: newValue
    })
  } else {
    throw (new Error('title 과 subtitle 말고 딴걸 업데이트하려고함'))
  }

  if (process.env.NODE_ENV !== 'production') {
    console.tron.display({
      name: 'updateNode 2',
      value: {
        newGTD
      }
    // , important: true
    })
  }
}

export const getParentKey = (node) => (node.editableValues ? node.editableValues.parentId || node.parentId : undefined)
